export enum PathwayStateEnum {
  PUBLISHED = 'published',
  DRAFT = 'draft'
}

export enum PathwayNotificationMessage {
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  P4 = 'P4'
}

export enum PathwayProgressEnum {
  LINEAR = 'linear',
  OPEN = 'open',
  LOCKED = 'locked'
}

export enum PathwayCompletedStatusEnum {
  SUCCESS = 'success',
  FAILED = 'failed'
}

export interface IPathway {
  id: number
  title: string
  description: string
  is_public: boolean
  state: PathwayStateEnum
  published_date: string
  progress: PathwayProgressEnum
  created_at: string
  updated_at: string | null
  private_topics: number
  organisation_id: number
  production_pathway_version_id: number
  created_by: number
  allow_comments: boolean
  deleted_at: string | null
}
